import React from "react";

const FinalizedStatusContext = React.createContext({});

export default FinalizedStatusContext;
